<script lang="ts" setup>
    import {onMounted} from "vue";
    import {useRoute, useRouter} from "vue-router";

    import SingleProductDetails from "../../components/product/SingleProductDetails.vue";

    import DCarouselSlide from "@songfinch/design-system/src/atoms/DCarouselSlide.vue";

    import DProductCard from "@songfinch/design-system/src/cards/DProductCard.vue";
    import DContainer from "@songfinch/design-system/src/atoms/DContainer.vue";

    import DCarouselBlock from "@songfinch/design-system/src/blocks/DCarouselBlock.vue";

    import {useProducts}  from "@songfinch/composables/src/products/useProducts";

    const route = useRoute();
    const router = useRouter();

    const {filteredAndSortedProducts, search} = useProducts();

    const handleProductError = () => {
        router.push({name: "404"});
    };

    onMounted(async () => {
        await search();
    });
</script>

<template>
    <DContainer>
        <SingleProductDetails :productId="(route.params.product_id as string)" @error="handleProductError"/>

        <DCarouselBlock
            v-if="filteredAndSortedProducts"
            variant="minimal"
            theme="white"
            dataTestId="product-products-carousel"
            heading="You might also like"
        >
            <template #carousel>
                <DCarouselSlide v-for="(recommendedProduct, i) in filteredAndSortedProducts" :key="i">
                    <DProductCard
                        class="product-carousel-card"
                        dataTestId="`product-products-carousel-product-card`"
                        :product="recommendedProduct"
                        :showButton="false"
                    />
                </DCarouselSlide>
            </template>
        </DCarouselBlock>
    </DContainer>
</template>

<style lang="scss" scoped>
    .product-carousel-card {
        width: 210px;

        @include md {
            width: 276px;
        }
    }

    .product-single-song-selector {
        margin-bottom: 1rem;
    }
</style>
